import Vue from 'vue'

const SET_GLOBAL_ALERT = (state, payload) => {
  if (!payload || (payload.show && !payload.text)) {
    throw 'Invalid arguments for global alert'
  }
  Vue.set(state, 'alert', payload)
}

const SET_GLOBAL_ERROR_ALERT = (state, payload) => {
  if (!payload || (payload.show && !payload.text)) {
    throw 'Invalid arguments for global error alert'
  }
  Vue.set(state, 'errorAlert', payload)
}

const SET_GLOBAL_INFO = (state, payload) => {
  if (!payload || (payload.show && !payload.text)) {
    throw 'Invalid arguments for global info'
  }
  Vue.set(state, 'info', payload)
}

const SET_LOADING = (state, payload) => {
  Vue.set(state, 'loading', payload)
}

const SET_USER = (state, payload) => {
  if (!payload) {
    throw 'Invalid arguments for user'
  }

  Vue.set(state, 'user', payload)
}
const SET_DASHBOARD = (state, payload) => {
  if (!payload) {
    throw 'Invalid arguments for user'
  }
  Vue.set(state, 'dashboard', payload)
}
const SET_FEATURE_FLAGS = (state, payload) => {
  Vue.set(state, 'featureFlags', payload)
}
const SET_FEATURES_LOADED = (state, payload) => {
  Vue.set(state, 'featuresLoaded', payload)
}
const SET_PREFERENCES = (state, payload) => {
  Vue.set(state, 'preferences', payload)
}
const UPDATE_PREFERENCE = (state, payload) => {
  const index = state.preferences.findIndex(p => p.preferenceId === payload.preferenceId)
  if (index >= 0) {
    state.preferences.splice(index, 1)
    state.preferences.push(payload)
  } else {
    state.preferences.push(payload)
  }
}
const SET_ACTIVE_ACCOUNT = (state, payload) => {
  if (!payload) {
    throw 'Invalid arguments for active Account'
  }
  Vue.set(state, 'activeAccount', payload)
}
const SET_ACCOUNT_ROLES = (state, payload) => {
  if (!payload) {
    throw 'Invalid arguments for authed accounts'
  }
  Vue.set(state, 'accountRoles', payload)
}
const SET_ACCOUNT_TASKS = (state, payload) => {
  Vue.set(state, 'accountTasks', payload)
}
const SET_BROKER_ROLES = (state, payload) => {
  if (!payload) {
    throw 'Invalid arguments for broker roles'
  }
  Vue.set(state, 'brokerRoles', payload)
}
const SET_BROKERAGES = (state, payload) => {
  if (!payload) {
    throw 'Invalid arguments for brokerages'
  }
  Vue.set(state, 'brokerages', payload)
}
const SET_CODE_SPLIT_REFRESH_NOTICE = (state, payload) => {
  if (!payload) {
    throw 'Invalid arguments for authed accounts'
  }
  Vue.set(state, 'showCodeSplittingRefresh', payload)
}

const SET_REFRESH_INTERVAL_NAME = (state, payload) => {
  if (!payload) {
    throw 'Interval name is required'
  }
  Vue.set(state, 'tokenIntervalName', payload)
}

const SET_AUTH_IS_REFRESHING = (state, payload) => {
  if (payload === undefined || payload === null) {
    throw 'boolean payload - auth isRefreshing required'
  }
  Vue.set(state.auth, 'isRefreshing', payload)
}
const SET_AUTH_REFRESH_CALL = (state, payload) => {
  Vue.set(state.auth, 'refreshingCall', payload)
}

const SET_APPLICATION_MODEL = (state, payload) => {
  Vue.set(state, 'formModel', payload)
}

const SET_ACCOUNT_NOTIFICATIONS = (state, payload) => {
  Vue.set(state, 'accountNotifications', payload)
}

const ADD_ACCOUNT_NOTIFICATION = (state, payload) => {
  if (!Array.isArray(state.accountNotifications)) {
    Vue.set(state, 'accountNotifications', [])
  }

  const newNotification = {
    ...payload,
    time: new Date().toISOString(),
  }
  const newAccountNotifications = [newNotification, ...state.accountNotifications]
  Vue.set(state, 'accountNotifications', newAccountNotifications)
}

const REMOVE_ACCOUNT_NOTIFICATION = (state, index) => {
  if (state.accountNotifications && state.accountNotifications.length > index) {
    const newArray = [...state.accountNotifications]
    newArray.splice(index, 1)
    Vue.set(state, 'accountNotifications', newArray)
  }
}

const CLEAR_ALL_ACCOUNT_NOTIFICATIONS = state => {
  Vue.set(state, 'accountNotifications', [])
}

const SET_SERVER_EVENT_SOURCE = state => {
  Vue.set(state, 'serverEventsSource', state)
}

const SET_REDIRECT_URL = (state, payload) => {
  Vue.set(state, 'redirectUrl', payload)
}

export default {
  SET_GLOBAL_ALERT,
  SET_GLOBAL_ERROR_ALERT,
  SET_GLOBAL_INFO,
  SET_LOADING,
  SET_USER,
  SET_ACTIVE_ACCOUNT,
  SET_ACCOUNT_ROLES,
  SET_ACCOUNT_TASKS,
  SET_DASHBOARD,
  SET_FEATURE_FLAGS,
  SET_FEATURES_LOADED,
  SET_PREFERENCES,
  UPDATE_PREFERENCE,
  SET_CODE_SPLIT_REFRESH_NOTICE,
  SET_REFRESH_INTERVAL_NAME,
  SET_BROKER_ROLES,
  SET_BROKERAGES,
  SET_AUTH_IS_REFRESHING,
  SET_AUTH_REFRESH_CALL,
  SET_APPLICATION_MODEL,
  SET_ACCOUNT_NOTIFICATIONS,
  ADD_ACCOUNT_NOTIFICATION,
  REMOVE_ACCOUNT_NOTIFICATION,
  CLEAR_ALL_ACCOUNT_NOTIFICATIONS,
  SET_SERVER_EVENT_SOURCE,
  SET_REDIRECT_URL,
}
